import React from 'react';
import PropTypes from 'prop-types';

import { Category } from '@menu/components';
import { sendToGA } from '@react-shared/helpers/send-to-ga';

class MenuContent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedCategoryID: -1,
      clickedElement: false,
    }
    
    this.handleClick = this.handleClick.bind(this);
    this.collapseMenu = this.collapseMenu.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick, true);
  }

  componentDidUpdate() {
    if (this.props.mobile && this.state.clickedElement) {
      setTimeout(() => {this.scrollToClickedLabel()}, 0);
    }
  }

  scrollToClickedLabel() {
    let selectedLabel = $(this.state.clickedElement);
    if (selectedLabel.length > 0) {
      let elementTop = selectedLabel.offset().top;
      let elementBottom = elementTop + selectedLabel.outerHeight();
      let viewportTop = $(window).scrollTop();
      let viewportBottom = viewportTop + $(window).height();
      let elementVisible = elementTop > viewportTop && viewportBottom > elementBottom;

      if (!elementVisible) {
        $('html, body').animate({ scrollTop: elementTop }, 300);
      }
    }
    this.setState({ clickedElement: false} );
  }

  collapseMenu() {
    this.setState({ selectedCategoryID: -1 });
  }

  handleClick(event) {
    var menuElements = document.querySelectorAll('#menu-nav > ul > li');
    var _ = this;
    var found = false;

    for (let i = 0; i < menuElements.length; i++) {
      if (menuElements[i].contains(event.target)) {
        found = true;
        break;
      }
    }

    if (!found) {
      _.collapseMenu();
      if (!$(event.target).hasClass('js-hamburger')) {
        $('.js-hamburger.active').trigger('click');
      }
    }
  }

  clickMenuCategory(sectionID) {
    sendToGA({
      event: 'Menu',
      action: 'MenuViewSelect',
      type: 'main'
    });

    if (this.state.selectedCategoryID === sectionID) {
      this.collapseMenu();
    } else {
      this.setState({
        selectedCategoryID: sectionID,
        clickedElement: '.selected-category-label'
      });
    }
  }

  render() {
    let sections = this.props.menuContent || [];

    return (
      <nav id="menu-nav">
        <ul>
          {sections.map((section) => (
            <Category
              key={"category-" + section.id}
              section={section}
              onClick={() => this.clickMenuCategory(section.id)}
              selected={this.state.selectedCategoryID === section.id}
              mobile={this.props.mobile}
              clickSection={(elem) => { this.setState({ clickedElement: elem }); }}
            />
          ))}
        </ul>
      </nav>
    );
  }
}

MenuContent.propTypes = {
  menuContent: PropTypes.array.isRequired,
  mobile: PropTypes.bool.isRequired
};

export default MenuContent;
